// extracted by mini-css-extract-plugin
export default {"root_scroller":"YV","flex_container":"ZV","container":"aW","scroller":"bW","indicator":"cW","scrollButtons":"eW","selected":"fW","root_tab":"gW","root_tab_scrollable":"hW","root_scroller_mob":"iW","scroller_mob":"jW","indicator_mob":"kW","selected_mob":"lW","root_tab_mob":"mW","root_tab_mob_scrollable":"nW"};
    if(module.hot) {
      // 1713211525816
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  